<template>
<div style="margin: 0 20px">
  <div style="height: 40px;margin: 10px 40px">
    <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
      <span>{{item.name}}</span>
    </div>
  </div>
  <div v-if="indexActive === 0">
    <el-form style="margin-right: 30px" :model="addEditForm" :rules="addEditRules" ref="addEditForm" label-width="110px" class="demo-ruleForm">
      <el-form-item label="供应商名称" prop="name">
        <el-input v-model="addEditForm.name" placeholder="请输入供应商名称"></el-input>
      </el-form-item>
      <el-form-item label="选择餐厅" prop="restaurantid">
        <el-select v-fixZoom v-model="addEditForm.restaurantid" filterable placeholder="请选择" :clearable="true" style="width:100%;" >
          <el-option v-for="item in restaurants" :key="item.index" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="">
        <el-input type="textarea" :rows="2" v-model="addEditForm.desc" placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <div style="height: 50px">
      <el-row style="margin: 0 20px">
        <el-col :span="12">
          <div class="cancel-btn" @click="closeAddEdit()">
            <span>取消</span>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="send-btn" @click="submitAddEdit('addEditForm')">
            <span>确定</span>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
  <div v-if="indexActive === 1">
    <vendor-file :infoRow="addEditObj.row"></vendor-file>
  </div>
</div>
</template>

<script>
import {addingredientvendor, updateingredientvendor} from '../../../api/yanglaoyuan'
import vendorFile from './vendorFile'
export default {
  name: 'addEditIngredient',
  components: {vendorFile},
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    addEditObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [
        {index: 0, name: '基本信息'},
        {index: 1, name: '资质证书'}
      ],
      indexActive: 0,
      restaurants: [],
      addEditForm: {
        'id': 0,
        'eid': 0,
        'name': '',
        desc: '',
        restaurantid: ''
      },
      addEditRules: {
        name: [
          {required: true, message: '请输入供应商名称', trigger: 'blur'}
        ],
        restaurantid: [
          {required: true, message: '请选择餐厅', trigger: 'change'}
        ]
      }
    }
  },
  created () {
    this.restaurants = this.addEditObj.restaurants
    if (!this.addEditObj.isAdd) {
      this.addEditForm.id = this.addEditObj.row.id
      this.addEditForm.eid = this.addEditObj.row.eid
      this.addEditForm.name = this.addEditObj.row.name
      this.addEditForm.restaurantid = this.addEditObj.row.restaurantid
      this.addEditForm.desc = this.addEditObj.row.desc
    } else {
      this.addEditForm.eid = this.$store.state.user.LoginResp.entity_id
    }
  },
  methods: {
    selectTab (item) {
      this.indexActive = item.index
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addEditObj.isAdd) {
            let data = {
              eid: this.addEditForm.eid,
              name: this.addEditForm.name,
              desc: this.addEditForm.desc,
              restaurantid: this.addEditForm.restaurantid
            }
            addingredientvendor(data).then(res => {
              this.$notify({title: '成功', message: '成功新增食材供应商', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            let data = {
              id: this.addEditForm.id,
              eid: this.addEditForm.eid,
              name: this.addEditForm.name,
              desc: this.addEditForm.desc,
              restaurantid: this.addEditForm.restaurantid
            }
            updateingredientvendor(data).then(res => {
              this.$notify({title: '成功', message: '成功编辑食材供应商', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/addEditIngredient.vue